/** @format */
import { CKEditor } from "@ckeditor/ckeditor5-react";
import FullEditor from "ckeditor5-build-full";
import { useFormikContext } from "formik";
import { useRef } from "react";
import ErrorMessage from "../Errors/ErrorMessage";

const TextEditor = ({ title, name, serverError }) => {
  const { errors, setFieldValue, values } = useFormikContext();
  const editorRef = useRef();

  return (
    <div className='form-group'>
      <label className='f-13 text-dark text-left d-flex flex-row justify-content-start'>
        {title}
      </label>
      <CKEditor
        editor={FullEditor}
        ref={editorRef}
        data={values[name]}
        config={{
          toolbar: {
            items: [
              "heading",
              "|",
              "bold",
              "italic",
              "underline",
              "link",
              "bulletedList",
              "numberedList",
              "subscript",
              "superscript",
              "fontSize",
              "fontFamily",
              "|",
              "fontColor",
              "fontBackgroundColor",
              "highlight",
              "alignment",
              "outdent",
              "indent",
              "-",
              "undo",
              "redo",
              "|",
              "imageUpload",
              "imageInsert",
              "toggleImageCaption",
              "imageTextAlternative",
              "linkImage",
              "mediaEmbed",
              "blockQuote",
              "insertTable",
              "horizontalLine",
              "htmlEmbed",
              "pageBreak",
              "removeFormat",
              "selectAll",
              "specialCharacters",
              "-",
              "sourceEditing",
              "strikethrough",
              "restrictedEditingException",
              "textPartLanguage",
              "style",
              "todoList",
              "codeBlock",
              "code",
              "findAndReplace",
              "fullScreen",
            ],
          },
          language: "fa",

          table: {
            contentToolbar: [
              "tableColumn",
              "tableRow",
              "mergeTableCells",
              "tableCellProperties",
              "tableProperties",
            ],
          },
        }}
        onChange={(event, editor) => {
          const data = editor.getData();
          setFieldValue(name, data, true);
        }}
      />
      <ErrorMessage error={errors[name] ? errors[name] : serverError} />
    </div>
  );
};

export default TextEditor;
